<template>
  <div
    class="voyage-item"
    @mouseover="$emit('cardHover', voyage)"
    @mouseleave="$emit('cardLeave')"
    @click="onVoyageSelected(voyage)"
  >
    <div class="voyage-item-content">
      <div class="voyage-title">
        {{ renderVoyageTitle(voyage) }}
      </div>
      <div class="voyage-vessel-info">
        <v-icon class="icon-style" small>mdi-ferry</v-icon>
        {{ voyage.vessel.description }}
      </div>
      <div class="voyage-calculation-info">
        <v-icon class="icon-style" small>mdi-calculator</v-icon>
        {{ voyage.createdAtDate }} - {{ voyage.createdAtTime }}
      </div>
      <VoyageInfoSummary :voyage="voyage" />
    </div>

    <v-btn icon v-if="showAction" @click.stop="onDeleteIconPressed(voyage)">
      <v-icon :color="getDeleteIconColor" class="delete-icon-style">
        mdi-delete-outline
      </v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="300px" max-height="100">
      <v-card>
        <v-card-title class="mt-2"
          ><v-row>
            <v-icon class="mr-1" color="blue">mdi-trash-can</v-icon>
            Delete voyage
          </v-row>
        </v-card-title>

        <v-card-text style="height: 100px">
          <v-col class="mt-1 pa-0">
            <p>Are you sure you want to delete the voyage</p>
          </v-col>
          <v-col class="mt-1 pa-0">
            <p>{{ selectedVoyageText }}</p>
          </v-col>
        </v-card-text>
        <v-btn
          color="primary"
          class="mr-2"
          outlined
          rounded
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="
            onConfirmDeletePressed(selectedVoyage.id, selectedVoyage.theyrId)
          "
        >
          Delete
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>
    <script>
import VoyageInfoSummary from "./VoyageInfoSummary.vue";
export default {
  name: "VoyageSummaryCard",
  components: {
    VoyageInfoSummary,
  },
  props: {
    voyage: Object,
    showAction: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    enableAction: false,
    dialog: false,
    selectedVoyage: "",
  }),
  computed: {
    getDeleteIconColor() {
      return this.enableAction ? "#E57373" : "#90A4AE";
    },
    selectedVoyageText() {
      return this.selectedVoyage != null ? this.selectedVoyage.description : "";
    },
  },
  methods: {
    onVoyageSelected(voyage) {
      this.$router.push({
        name: "Voyage Details",
        params: {
          vessel: this.$route.params.vessel,
          voyageId: voyage.theyrId,
        },
      });
    },
    renderVoyageTitle(voyage) {
      const description =
        voyage.description != ""
          ? voyage.description
          : "No description provided";
      return description;
    },
    onDeleteIconPressed(voyage) {
      this.selectedVoyage = voyage;
      this.dialog = true;
    },
    async onConfirmDeletePressed(voyageId, voyageTheyrId) {
      await this.$store.dispatch("weatherRouting/voyagesModule/deleteVoyage", {
        voyageId: voyageId,
        theyrId: voyageTheyrId,
      });
      this.dialog = false;
    },
    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/voyagesModule/filterVoyagesByDescription",
        {
          description: text,
        }
      );
    },
  },
};
</script>
    
    <style scoped>
.voyage-item {
  cursor: pointer;
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  padding: 16px;
  display: flex;
  align-items: start;
  justify-content: space-between;
}
.voyage-item:hover {
  border: 1px solid var(--color-secondary);
}
.voyage-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
}
.voyage-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 8px;
}
.voyage-item-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.voyage-vessel-info {
  font-size: 0.8rem;
  width: fit-content;
  color: var(--color-text);
}
.voyage-calculation-info {
  font-size: 0.8rem;
  width: fit-content;
  color: var(--color-text);
}
.icon-style {
  color: var(--color-text) !important;
}
.delete-icon-style {
  color: #90a4ae !important;
  transition: color 0.5s ease-in-out, scale 0.5s ease-in-out;
}
.delete-icon-style:hover {
  color: #e57373 !important;
  scale: 1.1;
}
</style>